import { useSelector } from 'react-redux';

import { ActiveRoles, ReduxStoreData } from '@funnels/types';

export const useActiveRolesFromStore = (): ActiveRoles | null => {
  return useSelector((state: ReduxStoreData) => state.activeRoles.data);
};
